import React, { Component } from 'react';
import './Product_thumbnails.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const styles = {
  mainImage: {
    width: '100%',
    cursor: 'pointer',
  },
  thumbnail: {
    cursor: 'pointer',
    border: "5px white solid",
    borderRadius: "3px"
  },
};

class Product_thumbnails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      activeSlide: 0,
      additionalMainImages: [],
    };
    this.isFirstUpdate = true;
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.isFirstUpdate || this.props.mainImage !== prevProps.mainImage) {
      this.isFirstUpdate = false;
      this.setState((prevState) => {
        // const additionalMainImages = [...prevState.additionalMainImages];
        const additionalMainImages = [];
        if (!additionalMainImages.includes(this.props.mainImage)) {
          additionalMainImages.unshift(this.props.mainImage);
        }
        const mainImageIndex = additionalMainImages.indexOf(this.props.mainImage);
        this.slider1.slickGoTo(mainImageIndex);
        return { activeSlide: mainImageIndex, additionalMainImages };
      });
    }
  }

  getThumbnailStyle = (index) => {
    const isSelected = this.state.activeSlide === index;
    return {
      ...styles.thumbnail,
      opacity: isSelected ? 1 : 0.5,
    };
  };

  getImagesWithMainImage = () => {
    const { images } = this.props;
    const { additionalMainImages } = this.state;
    return [...additionalMainImages, ...images];
  };

  getResizedThumbnailStyle = (index) => {
    const imagesWithMainImage = this.getImagesWithMainImage();
    const isSelected = this.state.activeSlide === index;
    const dynamicWidth = imagesWithMainImage.length < 5 ? (20 * imagesWithMainImage.length) : 100;
  
    return {
      ...styles.thumbnail,
      opacity: isSelected ? 1 : 0.5,
      width: `${dynamicWidth}%`,
    };
  };

  render() {
    const imagesWithMainImage = this.getImagesWithMainImage();
    const mainSliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      initialSlide: 0,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
    };

    const thumbnailSliderSettings = {
      slidesToShow: Math.min(imagesWithMainImage.length, 5),
      slidesToScroll: 1,
      focusOnSelect: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: Math.min(imagesWithMainImage.length, 5),
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: Math.min(imagesWithMainImage.length, 5),
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: Math.min(imagesWithMainImage.length, 5),
          },
        },
      ],
    };

    return (
      <div className="product-thumbnails-carousel">
        <div className="main-slider-wrapper">
            <Slider
            asNavFor={this.state.nav2}
            ref={(slider) => (this.slider1 = slider)}
            {...mainSliderSettings}
            >
            {imagesWithMainImage.map((image, index) => (
                <div key={index}>
                <img src={image} alt={`Product image ${index + 1}`} style={styles.mainImage} fetchpriority={index === 0?"high":"auto"}/>
                </div>
            ))}
            </Slider>
        </div>
        <div className="thumbnail-slider-wrapper">
            <Slider
            asNavFor={this.state.nav1}
            ref={(slider) => (this.slider2 = slider)}
            {...thumbnailSliderSettings}
            >
            {imagesWithMainImage.map((image, index) => (
                <div key={index}>
                <img src={image} alt={`Product thumbnail ${index + 1}`} style={this.getResizedThumbnailStyle(index)} />
                </div>
            ))}
            </Slider>
        </div>
      </div>
    );
  }
}

export default Product_thumbnails;


class PrevArrow extends Component {
  render() {
    const { onClick } = this.props;
    return (
      <div
        className="slick-arrow slick-prev"
        onClick={onClick}
        style={{ ...styles.arrow, left: "10px" }}
      >
        &#10094;
      </div>
    );
  }
}

class NextArrow extends Component {
  render() {
    const { onClick } = this.props;
    return (
      <div
        className="slick-arrow slick-next"
        onClick={onClick}
        style={{ ...styles.arrow, right: "10px" }}
      >
        &#10095;
      </div>
    );
  }
}
